<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal mt-16 my-8">
      <div class="flex justify-center mt-10"><check-mark-icon /></div>
      <div class="text-xl mt-4 font-bold text-root-2 flex justify-center">
        Deposit Successful
      </div>
      <div class="text-center text-root-4 mx-2">
        <p style="word-break: normal" class="my-3">
          A total of {{ parseMoney(plaidDepositAmount) }} has been charged to
          your bank account.
        </p>
      </div>
      <div class="mx-4 border-none my-8">
        <o-button @click="handleClose()">Done</o-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { ParseMoney } from '@/utils/helpers'
export default {
  name: 'DepositSuccessfulDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    parseMoney (val) {
      return ParseMoney(val)
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    plaidDepositAmount () {
      return this.$store.state.transactions.plaidDepositAmount
    }
  },
  components: {
    CheckMarkIcon: () => import('@/assets/icons/CheckMarkIcon.vue')
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
